import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import { calculateIndex } from "../../utlis/paginate";
import Help from "./Help";
import Pagination from "../../utlis/pagination";
import PageSizeOptions from "../../utlis/PageSizeOptions";
import {
  useLoadSupportTicketsQuery,
  useSendSupportTicketsMessageMutation,
  useLoadSupportBprmFormQuery,
  useLoadSupportCurrentWorkflowTaskMutation,
  useStartSupportApplicationMutation,
} from "../../app/store/supportApiSlice";
import { getCurrentUser } from "../../app/store/auth";
import { getFieldData } from "../../Services/appService";
import WorkflowElement from "../../app/components/WorkflowElement";
import useDocDownload from "../../app/hooks/useDocDownload";
import MessagingPopup from "../MessagingPopup";
import config from "../../config.json";

const SUPPORT_POPUP_STYLES = {
  modalContent: {
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "1220px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px"
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  closeAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0
  },
  addButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  addButtonDisabled: {
    opacity: 0.6,
    boxShadow: "none"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    minHeight: "520px",
    maxHeight: "calc(100vh - 160px)",
    overflowY: "auto",
    overflowX: "hidden"
  },
  workflowModalBody: {
    minHeight: "auto",
    padding: "18px 22px",
    maxHeight: "calc(100vh - 130px)"
  },
  workflowCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px"
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "14px",
    marginBottom: "16px"
  },
  statCard: {
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "16px 18px"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px"
  },
  statValue: {
    fontSize: "28px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1
  },
  statMeta: {
    marginTop: "8px",
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.6
  },
  tableSection: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  tableToolbar: {
    padding: "16px 18px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap"
  },
  tableTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#0f172a"
  },
  tableSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  tableWrap: {
    overflowX: "auto"
  },
  table: {
    width: "100%",
    minWidth: "980px",
    borderCollapse: "separate",
    borderSpacing: 0
  },
  tableHeadCell: {
    padding: "14px 16px",
    fontSize: "11px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    color: "#64748b",
    background: "#f8fafc",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)"
  },
  tableCell: {
    padding: "15px 16px",
    fontSize: "13px",
    color: "#334155",
    borderBottom: "1px solid rgba(241, 245, 249, 1)",
    verticalAlign: "top"
  },
  serialBadge: {
    width: "32px",
    height: "32px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(79,70,229,0.16) 100%)",
    color: "#4338ca",
    fontWeight: 600,
    fontSize: "12px"
  },
  ticketTitle: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.5
  },
  ticketMeta: {
    marginTop: "4px",
    fontSize: "12px",
    color: "#64748b"
  },
  docList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  docButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    borderRadius: "8px",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    textAlign: "left",
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  emptyText: {
    fontSize: "12px",
    color: "#94a3b8"
  },
  ticketBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "7px 12px",
    borderRadius: "999px",
    background: "rgba(37, 99, 235, 0.08)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 600
  },
  messageButton: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  unreadBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "22px",
    height: "22px",
    padding: "0 6px",
    borderRadius: "999px",
    background: "#ef4444",
    color: "#ffffff",
    fontSize: "11px",
    fontWeight: 600
  },
  readBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "22px",
    height: "22px",
    padding: "0 6px",
    borderRadius: "999px",
    background: "#dcfce7",
    color: "#166534",
    fontSize: "11px",
    fontWeight: 600
  },
  statusFixed: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    padding: "8px 12px",
    borderRadius: "999px",
    background: "rgba(34, 197, 94, 0.12)",
    color: "#166534",
    fontSize: "12px",
    fontWeight: 600
  },
  statusPending: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    padding: "8px 12px",
    borderRadius: "999px",
    background: "rgba(245, 158, 11, 0.14)",
    color: "#92400e",
    fontSize: "12px",
    fontWeight: 600
  },
  emptyState: {
    padding: "44px 24px",
    textAlign: "center"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 16px auto",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(79,70,229,0.16) 100%)",
    color: "#4338ca",
    fontSize: "24px"
  },
  emptyTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#0f172a"
  },
  emptySubtitle: {
    marginTop: "8px",
    fontSize: "13px",
    color: "#64748b",
    lineHeight: 1.7
  }
};

const SupportPupup = (props) => {
  const { issueShowHide, handleIssueShowHide } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [btnProcess, setBtnProcess] = useState(false);
  const [reqCount, setReqCount] = useState(0);
  const [workflowTask, setWorkflowTask] = useState(null);
  const [helpShowHide, setHelpShowHide] = useState(false);
  const [msgObj, setMsgObj] = useState(null);
  const [msgShowHide, setMsgShowHide] = useState(false);
  const [supObj, setSupObj] = useState(null);

  const currentUser = getCurrentUser();

  const { data: supportTicketsData, refetch: refetchTickets } = useLoadSupportTicketsQuery(
    { id: currentUser?.id, pageSize, pageNumber: currentPage },
    { skip: !currentUser?.id || !issueShowHide }
  );

  const supportTickets = useMemo(() => supportTicketsData?.data || [], [supportTicketsData]);
  const totalCount = useMemo(() => supportTicketsData?.totalCount || 0, [supportTicketsData]);

  const [startSupportApplication, { data: supportAppStartedData, reset: resetStartApp }] =
    useStartSupportApplicationMutation();

  const [loadSupportCurrentWorkflowTask, { data: currentSupportWorkflowTask, isSuccess: currentTaskLoadSuccess, reset: resetWorkflowTask }] =
    useLoadSupportCurrentWorkflowTaskMutation();

  const { data: supportBprmForm } = useLoadSupportBprmFormQuery(
    workflowTask?.formId,
    { skip: !workflowTask?.formId }
  );

  // Gate on workflowTask: RTK Query's `data` keeps the LAST fetched form even
  // after the query becomes skipped, so after the final task completes
  // (workflowTask reset to null) the modal kept showing an empty workflow
  // card instead of returning to the ticket list.
  const wfForm = workflowTask ? supportBprmForm || null : null;

  const [sendSupportTicketsMessage] = useSendSupportTicketsMessageMutation();

  const [handleDownloadFile] = useDocDownload();

  // Reset workflow and app starting states when modal closes/opens
  useEffect(() => {
    if (!issueShowHide) {
      resetStartApp();
      resetWorkflowTask();
      setWorkflowTask(null);
      setBtnProcess(false);
      setReqCount(0);
    }
  }, [issueShowHide, resetStartApp, resetWorkflowTask]);

  // Polling trigger: check task status after support app starts
  useEffect(() => {
    let timer;
    if (supportAppStartedData?.ciid > 0) {
      timer = setTimeout(() => {
        loadSupportCurrentWorkflowTask(supportAppStartedData);
        setReqCount(1);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [supportAppStartedData, loadSupportCurrentWorkflowTask]);

  // Polling loop
  useEffect(() => {
    let timer;
    if (currentSupportWorkflowTask) {
      if (currentSupportWorkflowTask.formId === null && reqCount <= 5 && reqCount > 0) {
        timer = setTimeout(() => {
          loadSupportCurrentWorkflowTask(supportAppStartedData);
          setReqCount((prev) => prev + 1);
        }, 3000);
      } else if (currentSupportWorkflowTask.wiid > 0) {
        setWorkflowTask(currentSupportWorkflowTask);
        setBtnProcess(false);
      } else if (reqCount === 0 || reqCount >= 3) {
        setReqCount(0);
        setWorkflowTask(null);
        refetchTickets();
        setBtnProcess(false);
      }
    } else if (currentTaskLoadSuccess && reqCount > 0) {
      // Last task finished: the server returned no next task,
      // so reset the workflow view and go back to the ticket list.
      setReqCount(0);
      setWorkflowTask(null);
      refetchTickets();
      setBtnProcess(false);
    }
    return () => clearTimeout(timer);
  }, [currentSupportWorkflowTask, currentTaskLoadSuccess, reqCount, supportAppStartedData, loadSupportCurrentWorkflowTask, refetchTickets]);

  const handleRunApplication = useCallback(() => {
    setBtnProcess(true);
    const newApplication = {
      workflowId: config.WorkflowIds.SupportWorkfowId,
      performerId: parseInt(currentUser?.id || 0, 10),
      applicationId: 1,
    };
    startSupportApplication(newApplication);
    setHelpShowHide(true);
  }, [currentUser, startSupportApplication]);

  const handleNextTask = useCallback((btnType) => {
    if (btnType && typeof btnType === "object" && (btnType.wiid > 0 || btnType.id > 0)) {
      setWorkflowTask(btnType);
    } else if (btnType === "taskCompleted") {
      setReqCount(0);
      setWorkflowTask(null);
      resetStartApp();
      resetWorkflowTask();
      setBtnProcess(false);
      refetchTickets();
    } else {
      setTimeout(() => {
        loadSupportCurrentWorkflowTask(workflowTask);
        setReqCount(1);
      }, 3000);
    }
  }, [workflowTask, refetchTickets, resetStartApp, resetWorkflowTask, loadSupportCurrentWorkflowTask]);

  const handleMessagePopup = useCallback((msg) => {
    if (!msg) {
      setSupObj(null);
      setMsgObj(null);
      setMsgShowHide(false);
    } else {
      setSupObj(msg);
      const obj = { ...msg, id: msg.commId };
      setMsgShowHide(true);
      setMsgObj(obj);
    }
  }, []);

  const handleHelpShowHide = useCallback(() => {
    setHelpShowHide((prev) => !prev);
  }, []);

  const handlePageSizeChanged = useCallback(({ currentTarget }) => {
    const nextPageSize = parseInt(currentTarget.value, 10);
    setPageSize(nextPageSize);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(nextPageSize);
  }, []);

  const handlePageChange = useCallback((page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(
      page,
      startIndex,
      endIndex
    );
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
  }, [startIndex, endIndex]);

  const handleSendMessage = useCallback(() => { }, []);

  const handleSupportMessage = useCallback((msg, msgAttachmentObj) => {
    if (msg !== "" && supObj) {
      const suppportObj = {
        id: supObj.ciid,
        message: msg,
        userId: parseInt(currentUser?.id || 0, 10),
        commId: supObj.commId || 0,
        performerId: supObj.performerId || 0,
        ciid: supObj.ciid || 0,
        wiid: supObj.wiid || 0,
        iiid: supObj.iiid || 0,
        uploadId: msgAttachmentObj?.docUploadId || 0,
      };
      sendSupportTicketsMessage(suppportObj);
    }
  }, [supObj, currentUser, sendSupportTicketsMessage]);

  const unreadCount = useMemo(() => {
    return supportTickets.reduce(
      (total, item) => total + (item.unreadCount || 0),
      0
    );
  }, [supportTickets]);

  const fixedCount = useMemo(() => {
    return supportTickets.filter((item) => item.appApproved).length;
  }, [supportTickets]);

  return (
    <>
      <Modal
        show={issueShowHide}
        size="xl"
        centered
        onHide={handleIssueShowHide}
        dialogClassName="support-popup-modal-dialog"
        contentClassName="support-popup-modal-content"
      >
        <style>
          {`
            .support-popup-modal-dialog {
              max-width: ${SUPPORT_POPUP_STYLES.modalDialog.maxWidth};
            }
            .support-popup-modal-content {
              border-radius: ${SUPPORT_POPUP_STYLES.modalContent.borderRadius};
              overflow: ${SUPPORT_POPUP_STYLES.modalContent.overflow};
              border: ${SUPPORT_POPUP_STYLES.modalContent.border};
              box-shadow: ${SUPPORT_POPUP_STYLES.modalContent.boxShadow};
            }
          `}
        </style>
        <Modal.Header style={SUPPORT_POPUP_STYLES.modalHeader}>
          <div style={SUPPORT_POPUP_STYLES.headerContent}>
            <Modal.Title as="div" style={SUPPORT_POPUP_STYLES.titleWrap}>
              <div style={SUPPORT_POPUP_STYLES.headerIcon}>
                <i className="fa fa-life-ring" aria-hidden="true"></i>
              </div>
              <div>
                <div style={SUPPORT_POPUP_STYLES.title}>Customer Support Portal</div>
                <div style={SUPPORT_POPUP_STYLES.subtitle}>
                  Review existing tickets, open a new issue, and continue support conversations.
                </div>
              </div>
            </Modal.Title>
            <div style={SUPPORT_POPUP_STYLES.headerActions}>
              {!workflowTask && (
                <button
                  type="button"
                  style={{
                    ...SUPPORT_POPUP_STYLES.addButton,
                    ...(btnProcess ? SUPPORT_POPUP_STYLES.addButtonDisabled : {})
                  }}
                  onClick={handleRunApplication}
                  disabled={btnProcess}
                >
                  {btnProcess ? (
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true"></i>
                  )}
                  Add Issue
                </button>
              )}
              <button
                type="button"
                style={SUPPORT_POPUP_STYLES.closeButton}
                onClick={handleIssueShowHide}
                aria-label="Close support popup"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            ...SUPPORT_POPUP_STYLES.modalBody,
            ...(wfForm ? SUPPORT_POPUP_STYLES.workflowModalBody : {})
          }}
        >
          {wfForm ? (
            <div style={SUPPORT_POPUP_STYLES.workflowCard}>
              <WorkflowElement
                wfTask={workflowTask}
                wfForm={wfForm}
                handleNextTask={handleNextTask}
                actionType={"workflow"}
              />
            </div>
          ) : (
            <>
              <div style={SUPPORT_POPUP_STYLES.helperCard}>
                <div style={SUPPORT_POPUP_STYLES.helperTitle}>Ticket guidance</div>
                <p style={SUPPORT_POPUP_STYLES.helperText}>
                  Create a new issue when you need help, attach supporting documents when available,
                  and use the discussion action to review replies from the support team.
                </p>
              </div>

              <div style={SUPPORT_POPUP_STYLES.statsGrid}>
                <div style={SUPPORT_POPUP_STYLES.statCard}>
                  <div style={SUPPORT_POPUP_STYLES.statLabel}>Total Tickets</div>
                  <div style={SUPPORT_POPUP_STYLES.statValue}>{totalCount || supportTickets.length}</div>
                  <div style={SUPPORT_POPUP_STYLES.statMeta}>
                    Your current support requests across the portal.
                  </div>
                </div>
                <div style={SUPPORT_POPUP_STYLES.statCard}>
                  <div style={SUPPORT_POPUP_STYLES.statLabel}>Unread Replies</div>
                  <div style={SUPPORT_POPUP_STYLES.statValue}>{unreadCount}</div>
                  <div style={SUPPORT_POPUP_STYLES.statMeta}>
                    New updates waiting in ongoing ticket discussions.
                  </div>
                </div>
                <div style={SUPPORT_POPUP_STYLES.statCard}>
                  <div style={SUPPORT_POPUP_STYLES.statLabel}>Fixed Issues</div>
                  <div style={SUPPORT_POPUP_STYLES.statValue}>{fixedCount}</div>
                  <div style={SUPPORT_POPUP_STYLES.statMeta}>
                    Tickets marked resolved by the support team.
                  </div>
                </div>
              </div>

              <div style={SUPPORT_POPUP_STYLES.tableSection}>
                <div style={SUPPORT_POPUP_STYLES.tableToolbar}>
                  <div>
                    <div style={SUPPORT_POPUP_STYLES.tableTitle}>Issue History</div>
                    <div style={SUPPORT_POPUP_STYLES.tableSubtitle}>
                      Track your submitted issues, attachments, and support responses.
                    </div>
                  </div>
                  <PageSizeOptions
                    pageSize={pageSize}
                    onChange={handlePageSizeChanged}
                  />
                </div>

                {supportTickets.length > 0 ? (
                  <>
                    <div style={SUPPORT_POPUP_STYLES.tableWrap}>
                      <table style={SUPPORT_POPUP_STYLES.table}>
                        <thead>
                          <tr>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}></th>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}>Date & Time</th>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}>Issue</th>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}>Attachments</th>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}>Ticket ID</th>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}>Discussion</th>
                            <th style={SUPPORT_POPUP_STYLES.tableHeadCell}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {supportTickets.map((item, key) => (
                            <tr key={`${item.ciid || "ticket"}-${key}`}>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                <span style={SUPPORT_POPUP_STYLES.serialBadge}>{key + 1}</span>
                              </td>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                {item.startDateTime ? (
                                  <>
                                    <div style={SUPPORT_POPUP_STYLES.ticketTitle}>
                                      <Moment format="MMM Do YYYY">
                                        {item.startDateTime}
                                      </Moment>
                                    </div>
                                    <div style={SUPPORT_POPUP_STYLES.ticketMeta}>
                                      <Moment format="h:mm a">
                                        {item.startDateTime}
                                      </Moment>
                                    </div>
                                  </>
                                ) : (
                                  <span style={SUPPORT_POPUP_STYLES.emptyText}>Not available</span>
                                )}
                              </td>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                <div style={SUPPORT_POPUP_STYLES.ticketTitle}>
                                  {getFieldData(
                                    item.stateData,
                                    "customersupportportal",
                                    "Issue_Name"
                                  ) || "Untitled issue"}
                                </div>
                                <div style={SUPPORT_POPUP_STYLES.ticketMeta}>
                                  Support request raised through the customer portal.
                                </div>
                              </td>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                {item.documents?.length ? (
                                  <div style={SUPPORT_POPUP_STYLES.docList}>
                                    {item.documents.map((doc, docIndex) => (
                                      <button
                                        key={`${doc.documentName || "doc"}-${docIndex}`}
                                        type="button"
                                        style={SUPPORT_POPUP_STYLES.docButton}
                                        onClick={() => handleDownloadFile(doc)}
                                      >
                                        <i className="fa fa-paperclip" aria-hidden="true"></i>
                                        {doc.documentName}
                                      </button>
                                    ))}
                                  </div>
                                ) : (
                                  <span style={SUPPORT_POPUP_STYLES.emptyText}>No attachments</span>
                                )}
                              </td>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                <span style={SUPPORT_POPUP_STYLES.ticketBadge}>#{item.ciid}</span>
                              </td>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                <button
                                  type="button"
                                  style={SUPPORT_POPUP_STYLES.messageButton}
                                  onClick={() => handleMessagePopup(item)}
                                >
                                  <i className="fa fa-comments-o" aria-hidden="true"></i>
                                  View / Reply
                                  {item.unreadCount > 0 ? (
                                    <span style={SUPPORT_POPUP_STYLES.unreadBadge}>
                                      {item.unreadCount}
                                    </span>
                                  ) : item.readCount > 0 ? (
                                    <span style={SUPPORT_POPUP_STYLES.readBadge}>
                                      {item.readCount}
                                    </span>
                                  ) : null}
                                </button>
                              </td>
                              <td style={SUPPORT_POPUP_STYLES.tableCell}>
                                {item.appApproved ? (
                                  <span style={SUPPORT_POPUP_STYLES.statusFixed}>
                                    <i className="fa fa-check-circle" aria-hidden="true"></i>
                                    Fixed
                                  </span>
                                ) : (
                                  <span style={SUPPORT_POPUP_STYLES.statusPending}>
                                    <i className="fa fa-clock-o" aria-hidden="true"></i>
                                    Pending
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={totalCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    />
                  </>
                ) : (
                  <div style={SUPPORT_POPUP_STYLES.emptyState}>
                    <div style={SUPPORT_POPUP_STYLES.emptyIcon}>
                      <i className="fa fa-life-ring" aria-hidden="true"></i>
                    </div>
                    <div style={SUPPORT_POPUP_STYLES.emptyTitle}>No support tickets yet</div>
                    <div style={SUPPORT_POPUP_STYLES.emptySubtitle}>
                      Start a new support request to report an issue or ask for help from the
                      customer support team.
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={SUPPORT_POPUP_STYLES.modalFooter}>
          <div style={SUPPORT_POPUP_STYLES.footerActions}>
            <button
              type="button"
              style={SUPPORT_POPUP_STYLES.closeAction}
              onClick={handleIssueShowHide}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Help
        helpShowHide={helpShowHide}
        handleHelpShowHide={handleHelpShowHide}
        module="Support"
      />

      <MessagingPopup
        msgShowHide={msgShowHide}
        message={msgObj}
        handleMsgModalShowHide={handleMessagePopup}
        handleSendMessage={handleSendMessage}
        handleSupportMessage={handleSupportMessage}
      />
    </>
  );
};

export default SupportPupup;
